import { FaIcon, IconProps } from './faIcon';

export function EditIcon(props: Omit<IconProps, 'name'>) {
  return <FaIcon name="pen" {...props} />;
}
